
    export default {
      name: "fileUpload",
      props: {
        uploadHeight: {
          type: [Number, String],
          default: 130
        },
        uploadWidth: {
          type: [Number, String],
          default: 130
        },
        module: {
          type: String,
          default: 'COMPANY_DOC'
        }
      },
      data() {
        return {
          imageUrl: '',
          uploadStyle: {
            width: '130px',
            height: '130px'
          },
          iconStyle: {
            lineHeight: '0px'
          },
          fileType: '',
          fileName: '',
          fileList: [],
          hasUpload: false
        }
      },
      mounted() {
        this.uploadStyle.width = this.uploadWidth + 'px'
        this.uploadStyle.height = this.uploadHeight + 'px'
        this.iconStyle.lineHeight = this.uploadHeight + 'px'
      },
      watch: {
        fileList(val) {
        }
      },
      methods: {
        handleAvatarSuccess(file, fileList) {
          this.$emit('loading')
          if (file.status === 'ready') {
            // check file size
            const isLt10M = file.size / 1024 / 1024 < 50;
            if (!isLt10M) {
              this.$message({
                message: 'The file you are uploading is too large. The file size cannot exceed 50 MB.',
                type: 'warning'
              })
              return
            }
            // check file type
            const isJpgOrPng = file.raw.type === 'image/jpeg' || file.raw.type === 'image/jpg' || file.raw.type === 'image/png';
            if (isJpgOrPng) {
              this.fileType = 'img'
            } else {
              this.fileType = 'pdf'
              this.fileName = file.name
            }
          }
          if (fileList.length > 0) {
            this.fileList = [fileList[fileList.length - 1]]
          }
    
          this.imageUrl = URL.createObjectURL(file.raw)
          this.hasUpload = true
          // this.$emit('loadSuccess')
        },
        async uploadImageRequest(params) {
            console.log('params====>', params)
          // this.$emit('loadStart')
          const formData = new FormData()
          formData.append('file', params.file)
          formData.append('module', this.module)
          console.log('formData', formData)
          const res = await this.$api.upload.uploadFile(formData)
          console.log('res=====>', res)
          this.sendFileId(res.data.data.id)
        },
        beforeFileUpload(file) {
          // check file size
          // const isLt10M = file.size / 1024 / 1024 < 10;
          // if(!isLt10M) {
          //   this.$message({
          //     message: 'The file you are uploading is too large. The file size cannot exceed 10 MB.',
          //     type: 'warning'
          //   })
          //   return false
          // }
        },
        sendFileId(val) {
          this.$emit('getFileId', val)
        },
        onUploadClick() {
          this.$refs.uploadDoc.submit()
        },
        handleChange(file, fileList) {
    
        },
      }
    }
    